module.exports = __webpack_public_path__ + "img/burger-menu-icon.6e87e086.svg";